const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.129,17.006H4.491V5.742H15.129a.626.626,0,0,0,.626-.626V3.239A1.253,1.253,0,0,0,14.5,1.988H4.491A1.253,1.253,0,0,0,3.239,3.239V20.761a1.254,1.254,0,0,0,1.252,1.251H14.5a1.254,1.254,0,0,0,1.252-1.251V17.632A.627.627,0,0,0,15.129,17.006ZM4.491,3.239H14.5V4.491H4.491ZM14.5,20.761H4.491v-2.5H14.5Z",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.509,6.994H12a1.254,1.254,0,0,0-1.252,1.251v5.007A1.254,1.254,0,0,0,12,14.5h1.252v.626a.625.625,0,0,0,.906.559l2.37-1.185h2.981a1.254,1.254,0,0,0,1.252-1.251V8.245A1.254,1.254,0,0,0,19.509,6.994Zm0,6.258H16.38a.623.623,0,0,0-.28.066l-1.6.8v-.239a.625.625,0,0,0-.626-.625H12V8.245h7.509Z",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.528,11.374a.626.626,0,1,0,0-1.251h-.012a.62.62,0,0,0-.62.625A.631.631,0,0,0,14.528,11.374Z",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.031,11.374a.626.626,0,1,0,0-1.251h-.012a.62.62,0,0,0-.62.625A.631.631,0,0,0,17.031,11.374Z",
    style: {
      fill: "black"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.210d438c478e1079ec5a3c367acdcb6e.svg";
export { ForwardRef as ReactComponent };